module.exports = __webpack_public_path__ + "img/google_on_white.e13ebeb0.png";